import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { environment } from '../../../../environments/environment';
import { FacilityDetailsService } from '../../services/facility-details.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { CommonUtil } from '../../../core/Utils/common-util';
import { Subscription } from 'rxjs';
import { SubscriptionService } from '../../services/subscription.service';
import { FlagObject } from 'src/app/core/halo-tips/halo-tips.model';
import { Router } from '@angular/router';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-digitalcoach-announcement-modal',
  templateUrl: './digitalcoach-announcement-modal.component.html',
  styleUrls: ['./digitalcoach-announcement-modal.component.css']
})
export class DigitalcoachAnnouncementModalComponent implements OnInit {

  // subscriptions
  private _facilityOnChange: Subscription;
  private _currentFacility: FacilityObject;

  currentFacility: FacilityObject;
  popupData: any = {};

  constructor
    (private rootScopeService: RootScopeService,
      private facilityDetailService: FacilityDetailsService,
      private _facilityService: FacilityService,
      public commonUtil: CommonUtil,
      private _amplitudeAnalytics: AmplitudeAnalyticsService,
      private _subscriptionService: SubscriptionService,
      private router: Router
    ) { }
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  digitalCoachPopUpMsg: string;

  @Output() onClose: EventEmitter<any> = new EventEmitter();
  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this._currentFacility = this._facilityService.selectedFacility();
    this.popupData = this._facilityService.getAnnouncements() || {};
    this.getRootScopeData();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;

    });
  }

  updateHideDigitalCoachModal(goToScreen: string) {
    if (goToScreen === 'setup') {      
      this.goToDigitalCoachPage();
      this.onClose.emit({isNavigated: true});
    } else {      
      this.onClose.emit();
    }
    this.rootScopeData.popupData.showDigitalCoachPopup = false;
  }

  goToDigitalCoachPage() {
    this.router.navigate(['/digital_coach/workout_builder']);
  }
}
